import React from "react";
import { useState } from "react";
import { GoogleLogin } from "react-google-login";

const LoginGoogle = (props) => {
  const [IsLoading, setIsLoading] = useState(false);

  const handleSocialLogin = (user) => {
    if (IsLoading) return;
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + props.token.access_token);
    myHeaders.append("Accept", "application/json");

    var formdata = new FormData();
    formdata.append("sessione", props.sessionKey);
    formdata.append("mail", user.profileObj.email);
    formdata.append("google_id", user.profileObj.googleId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://ws.mediatoys.it/cliente/loginGoogle", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result[0].nome === "") {
          result[0].nome = user.profileObj.givenName;
        }
        props.userUpdate(result[0]);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const handleSocialLoginFailure = (err) => {
    console.error(err);
  };

  return (
    <div>
      <div>
        <GoogleLogin
          provider="google"
          clientId={props.cfg.googleId}
          onSuccess={handleSocialLogin}
          onFailure={handleSocialLoginFailure}
          cookiePolicy={"single_host_origin"}
          buttonText="Login con Google"
        ></GoogleLogin>
      </div>
    </div>
  );
};
export default LoginGoogle;
